// chart-race 动画：value 在相邻 timeline 帧之间线性插值（连续，非跳帧），
// items 按插值 value 降序排（rank 随 value 实时变化），跨帧 by label 匹配。
import type { SceneData } from '../../api/types'
import type { ChartRaceData, ChartRaceItem } from './types'

export function chartRaceInterpolate(
  d: SceneData,
  time: number,
  duration: number,
): { year: number; items: ChartRaceItem[] } {
  const data = d as unknown as ChartRaceData
  const tl = data.timeline || []
  const n = tl.length
  if (n === 0) return { year: 0, items: [] }
  const frameDur = duration / n
  const idx = Math.min(Math.floor(time / frameDur), n - 1)
  const next = Math.min(idx + 1, n - 1)
  const f = next > idx ? (time - idx * frameDur) / frameDur : 0
  const cur = tl[idx]
  const nxt = tl[next]
  const nxtMap = new Map((nxt.items || []).map((it) => [it.label, it]))
  const items: ChartRaceItem[] = []
  ;(cur.items || []).forEach((a) => {
    const b = nxtMap.get(a.label) || a
    items.push({ label: a.label, value: a.value + (b.value - a.value) * f, color: a.color })
  })
  items.sort((a, b) => b.value - a.value)
  const year = Math.round(cur.year + (nxt.year - cur.year) * f)
  return { year, items }
}
